import styled from "styled-components";

export const StyledDetails = styled.div`
  height: 100%;
  display: flex;
  padding: 0 10px;
  align-items: center;

  .r-button__icon {
    transform: rotate(-90deg);
  }
`;
